import _ from 'lodash'

class SearchController {
  constructor() {
  }
}

//SearchController.$inject = []

export default SearchController
